;(function () {
  angular
    .module('contrast.libraries')
    .controller('LibraryScoreBreakdownCtrl', LibraryScoreBreakdownCtrl)
  function LibraryScoreBreakdownCtrl(
    $scope,
    $uibModal,
    $routeParams,
    $translate,
    metricService,
    pieChartOptionsService,
    LibraryFactory,
    ApplicationFactory,
    ServerFactory,
    ErrorService,
    ChartConstants
  ) {
    'ngInject'

    var appId = $routeParams.appId
    var serverId = $routeParams.serverId

    var translGlobal = {
      library: $translate.instant(
        'plural_libraries',
        { count: 1 },
        'messageformat'
      ),
      libraries: $translate.instant(
        'plural_libraries',
        { count: 2 },
        'messageformat'
      ),
      title_letterGrade_score: $translate.instant('title_letterGrade_score'),
      title_libraryStatistics_count_libraries: $translate.instant(
        'title_libraryStatistics_count_libraries'
      ),
      title_libraryStatistics_averageLibraryGrade: $translate.instant(
        'title_libraryStatistics_averageLibraryGrade'
      ),
      title_libraryStatistics_statusUnknownLibraries: $translate.instant(
        'title_libraryStatistics_statusUnknownLibraries',
        { libraryPropName: $translate.instant('title_score') },
        'messageformat'
      )
    }

    $scope.showGraph = true

    $scope.chart = {}
    $scope.chart.data = []
    $scope.chart.options = angular.copy(pieChartOptionsService.get())
    $scope.chart.options.tooltipOpts.content = function (label, xval, yval) {
      return (
        "<span class='size-h3'>" +
        translGlobal.title_letterGrade_score +
        ': <b>%s</b>, ' +
        translGlobal.title_libraryStatistics_count_libraries +
        ': ' +
        yval +
        '</span>'
      )
    }

    $scope.chart.options.legend = {
      show: true,
      labelFormatter: function (label, series) {
        var numApps = parseInt(series.data[0][1])
        return (
          '<strong>' +
          label +
          '</strong>: ' +
          series.data[0][1] +
          ' ' +
          (numApps > 1 || numApps === 0
            ? translGlobal.libraries
            : translGlobal.library)
        )
      }
    }
    $scope.chart.options.tooltipOpts = {
      shifts: {
        x: -10,
        y: -70
      },
      content: function (label, xval, yval) {
        var size = metricService.getSizeShorthand(yval, 0)
        return (
          "<span class='size-h4'><strong>%s</strong><br/>" +
          size +
          ' ' +
          (parseInt(yval) > 1 ? translGlobal.libraries : translGlobal.library) +
          '</span>'
        )
      },
      defaultTheme: false
    }

    $scope.chartParameters = {
      data: $scope.chart.data,
      options: $scope.chart.options,
      title: translGlobal.title_libraryStatistics_averageLibraryGrade
    }

    function init() {
      if (appId) {
        $scope.libScoreBreakdownPromise =
          ApplicationFactory.getLibrariesScoreBreakdown(appId)
      } else if (serverId) {
        $scope.libScoreBreakdownPromise =
          ServerFactory.getLibrariesScoreBreakdown(serverId)
      } else {
        $scope.libScoreBreakdownPromise =
          LibraryFactory.getLibrariesScoreBreakdown()
      }

      $scope.libScoreBreakdownPromise.then(function (response) {
        var breakdown = response.data.breakdown

        if (breakdown.length == 0) {
          $scope.showGraph = false
        } else {
          $scope.chart.letter = response.data.average_grade
          $scope.chart.score = response.data.average_score

          var charData = []
          for (var i = 0; i < breakdown.length; i++) {
            var item = breakdown[i]
            if (item.grade === '?') {
              charData.push({
                label:
                  translGlobal.title_libraryStatistics_statusUnknownLibraries,
                data: item.count,
                color: '#767676'
              })
            } else {
              charData.push({ label: item.grade, data: item.count })
            }
          }

          $scope.chart.data = charData
          $scope.chartParameters.data = charData
          $scope.showModal = ChartConstants.showModal($scope, $uibModal)
        }
      }, ErrorService.processError)
    }

    init()
  }
})()
